import { Group } from '../../../api/users/types';

export type DateState = {
  from: Date | null;
  to: Date | null;
};

export type RouteParams = { projectId: string };

export type SelectedGroups = {
  [key: string]: null | number;
};

export type Groups = {
  [key: number]: Group;
};

export enum GroupFilter {
  all = 'all',
  active = 'active',
  ban = 'ban'
}
